<template>
    <div class="search-bar-wrapper">
        <v-text-field
            v-model="query"
            append-outer-icon="search"
            class="search-box search"
            :label="$language.translate('Search products')"
            ref="searchInput"
            @input="search"
            @keyup.enter="applySearch"
            @keydown.down="delegateFocus"
            @keydown.esc="closeDropdown"
            @mousedown="openDropdown"
            @click:append-outer="search"
            @focus="freezeLayoutSwitch()"
            @blur="unfreezeLayoutSwitch()"
            :dark="dark"
        ></v-text-field>
        <search-dropdown
            ref="searchDropdown"
            :query="query"
        ></search-dropdown>
    </div>
</template>

<script>
import SearchDropdown from './SearchDropdown';
import debounce from 'lodash/debounce';
import { mapState, mapMutations, mapActions } from 'vuex';

const searchDropdownModuleName = 'SearchDropdown';
const searchResultsModuleName = 'SearchResults';

export default {
    name: 'SearchBox',
    data() {
        return {
            query: this.$route.params.query ? this.$route.params.query : '',
            lastSearchedByQuery: '',
            lastViewProducts: {},
            pushNext: true,
            queryParsed: false,
        };
    },
    props: {
        merchantName: {},
        dark: Boolean,
    },
    components: {
        SearchDropdown,
    },
    mounted() {
        window.addEventListener('popstate', this.onHistoryPopState);
    },
    beforeDestroy() {
        window.removeEventListener('popstate', this.onHistoryPopState);
    },
    computed: {
        ...mapState(searchResultsModuleName, ['allowSwitchLayout']),
        merchantId() {
            return this.$route.params.merchant;
        },
    },
    methods: {
        ...mapActions(searchDropdownModuleName, ['loadDropdownResults']),
        ...mapMutations(searchResultsModuleName, {
            setAllowSwitchLayout: 'SET_ALLOW_SWITCH_LAYOUT',
        }),
        onHistoryPopState() {
            this.query = this.$route.params.query;
        },
        startSearch: debounce(function() {
            this.lastSearchedByQuery = this.query;
            this.pushHistory(true, true, false);
            this.scrollPos = window.pageYOffset;
        }, 250),
        search() {
            if (this.lastSearchedByQuery === undefined && this.$router.currentRoute) {
                this.lastSearchedByQuery = this.$router.currentRoute.params.query;
            } else if (this.query && this.query.trim() != '' && this.query != this.lastSearchedByQuery) {
                this.startSearch();
                this.openDropdown();
            }
        },
        applySearch() {
            this.pushHistory(false);
            let isTouchDevice;
            try {
                document.createEvent('TouchEvent');
                isTouchDevice = true;
            } catch (e) {
                isTouchDevice = false;
            }
            if (isTouchDevice) {
                document.activeElement.blur();
            }
            this.closeDropdown();
        },
        merchantUnbind() {
            this.removeMerchantElements();
            this.$search.unsetMerchant();
            if (this.query) {
                this.$router.push({
                    path: this.$search.buildSearchParams(),
                });
            }
        },
        removeMerchantElements() {
            let merchantHeader = document.getElementById('merchant-header');
            if (merchantHeader) {
                document.getElementById('merchant-header').remove();
            }
            let merchant = document.getElementById('merchant');
            if (merchant) {
                document.getElementById('merchant').removeAttribute('id');
            }

            const styleLinks = document.querySelectorAll('link[data-ref="merchant-style"]');
            styleLinks.forEach(item => {
                if (item !== null) {
                    item.remove();
                }
            });
        },
        pushHistory(replace = true, reset = false, closeDropdown = true) {
            if (this.query) {
                let path = this.$search.buildSearchParams(
                    {
                        query: this.query,
                    },
                    reset,
                );

                if (!this.pushNext && this.$route.meta.isSearchRoute) {
                    this.$router.replace(path);
                } else {
                    this.$router.push(path);
                }
                this.pushNext = !replace;

                if (closeDropdown) {
                    this.closeDropdown();
                }
            }
        },
        delegateFocus() {
            let searchDropdown = this.$refs.searchDropdown;
            if (searchDropdown.showDropdown) {
                searchDropdown.selfFocus();
            } else {
                this.openDropdown();
            }
        },
        openDropdown() {
            if (this.$refs.searchDropdown.opened == false && this.query && this.query.trim() != '') {
                this.loadDropdownResults(this.query);
            }
            this.$refs.searchDropdown.openDropdown();
        },
        closeDropdown() {
            this.$refs.searchDropdown.closeDropdown();
        },
        focusInput() {
            this.$refs.searchInput.focus();
        },
        clearSearch() {
            this.query = '';
        },
        freezeLayoutSwitch() {
            this.setAllowSwitchLayout(false);
        },
        unfreezeLayoutSwitch() {
            this.setAllowSwitchLayout(true);
        },
    },
    watch: {
        $route(to, from) {
            if (this.queryParsed === false) {
                this.queryParsed = true;
                this.query = to.params.query;
            } else if (this.queryParsed && !to.params.hasOwnProperty('query')) {
                this.query = '';
            }
        }
    },
};
</script>
